import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ContainerGeneral from './components/containerGeneral';
import config from './config.json'
import './App.css';

function App() {
  
  window.onerror = function(error) {
    // do something clever here
    console.log("error");
  };
  return (
    <BrowserRouter basename={`/${config.urlBase}`}>
      <Routes>
        <Route path={":codigoSeccion/:codigoVisor/:tipo/:tiponav"}  element={<ContainerGeneral/>}/>
        <Route path={":codigoSeccion/:codigoVisor/:tipo"}  element={<ContainerGeneral/>}/>
        <Route path={":codigoSeccion/:codigoVisor"}  element={<ContainerGeneral/>}/>
        <Route path={":codigoBase/"}  element={<ContainerGeneral/>}/>
        <Route path={"/"}  element={<ContainerGeneral/>}/>
      </Routes>
    </BrowserRouter>
  ) 
}

export default App;
